import 'modernizr'; // eslint-disable-line
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import '../vendor/bootstrap';

import datepicker from '../modules/datepicker';
import embedWrap from '../modules/embedWrap';

const general = () => {
  datepicker.initialize();
  embedWrap();
  porta({
    messages: nl,
  });
};

export default general;
